export default __webpack_public_path__ + "3cc88a8623852265f7cc4c503bb0a335.jpg";